import { Component, OnInit, ViewChild } from "@angular/core";
// import { Router } from "@angular/router";
import { NotificationService } from "@app/core/services/notification.service";
import { I18nService } from '@app/shared/i18n/i18n.service';
import { BsLocaleService, BsModalRef, ModalDirective } from 'ngx-bootstrap';
// import { UserService } from "@app/core/services/user.service";
import { CommonService } from "@app/core/services/common.service";
// import { environment } from "@env/environment";
declare var $: any;

@Component({
  selector: "sa-clearCache",
  //   template: `
  // <div id="logout" (click)="showPopup()" class="btn-header transparent pull-right">
  //         <span> <a title="Sign Out"><i class="fa fa-sign-out"></i></a> </span>
  //     </div>
  //   `,
  template: `
    <div id="clearCache" (click)="showPopup()" class="transparent">
        <span class="nav_btn iom_btn">
          <a title="{{'common_clearcache' | i18n}}">
            <i class="fa fa-refresh"  style="font-size: 20x;"></i>
            <span id="clearCache_text" style="font-size: 14px;padding-left: 10px;">{{'common_clearcache' | i18n}}</span>
          </a>
        </span>
    </div>
    <div bsModal #smUpdateModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
        aria-hidden="true" id="myModal1">
        <div class="modal-dialog modal-sl modal-dialog-centered">
            <div class="modal-content modalBodyBgColor border" style="padding: 15px !important;  width: 800px;">
            <header class="">                                        
                <div class="pull-right crossDiv">
                    <a (click)="closePopup();" title="{{'common_close' | i18n}}">
                        <i class="fa fa-close crossBtn" aria-hidden="true"></i>
                    </a>
                </div>
                <h4 class="modal_header pl-3">{{'common_clearcache' | i18n}}</h4>
            </header>
                <div class="modal-body modalBody p-0">
                    <div class="modal-body modalBody payBody">
                        <h4>{{'common_clearcache_message'|i18n}}</h4>
                    </div>
                    <div class="MessageBoxButtonSection">
                      <button id="bot1-Msg1" class="btn btn-default btn-sm botTempo" (click)="clearCache()"> {{'common_yes' | i18n}}</button>
                      <button id="bot2-Msg1" class="btn btn-default btn-sm botTempo" (click)="closePopup()"> {{'common_no' | i18n}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  `,
  styles: ['.crossDiv{margin-top: -10px;margin-right: -7px;}.crossbtnDiv{ margin-top: 12px;margin-right: 2px;}.crossBtn{text-align: right;letter-spacing: 0px;color: #B7EB00; opacity: 1;font-size: 20px;font-weight: bold; }.modal_header {text-align: left;font: normal normal bold 16px/22px Open Sans !important;letter-spacing: 0px;opacity: 1;}']
})
export class ClearCacheComponent implements OnInit {

  public user
  userName = "";
  public modalRef: BsModalRef;
  @ViewChild('smUpdateModal') public smUpdateModal:ModalDirective;

  constructor(
    private notificationService: NotificationService,
   private _commonService: CommonService,
    private i18nService: I18nService
  ) {
  }

  showPopup() {
    this.smUpdateModal.show();
    $('#myModal1').appendTo("body").modal('show');
  }


  clearCache() {
    this._commonService.clearCookieStorage(true);
  }

  closePopup(){
    this.smUpdateModal.hide();
    $('#myModal1').modal('hide');
  }
  ngOnInit() { }
}
